import styled from 'styled-components'
import Paper from '@mui/material/Paper'

const Body = styled(Paper)`
  /* --app-header-height is published by the Header from the fixed AppBar's real
     height, so this offset tracks the bar even when the breadcrumbs wrap to two
     lines and make it taller. The literals are fallbacks until it's measured. */
  margin-top: var(--app-header-height, 56px);
  /* dvh (where supported) tracks the visible viewport, so there is no phantom
     scroll behind the mobile address bar and the area shrinks when the
     on-screen keyboard opens; vh stays as the fallback. */
  height: calc(100vh - var(--app-header-height, 56px));
  height: calc(100dvh - var(--app-header-height, 56px));
  overflow-y: auto;
  padding: 0 0 10px;

  @media (min-width: 600px) {
    margin-top: var(--app-header-height, 64px);
    height: calc(100vh - var(--app-header-height, 64px));
    height: calc(100dvh - var(--app-header-height, 64px));
  }

  @media (max-width: 599px) and (orientation: landscape) {
    margin-top: var(--app-header-height, 48px);
    height: calc(100vh - var(--app-header-height, 48px));
    height: calc(100dvh - var(--app-header-height, 48px));
  }

  @media print {
    height: auto;
    overflow: visible;
    margin-top: 0;
    padding: 0;
  }
`

export default Body